import "../CSS/Ploeg.css";

function U9A() {
  return (
    <div className="ploegoverzicht">
      <iframe
        className="klassement"
        src="https://www.voetbalvlaanderen.be/competitie/CHP_125544/overzicht"
      />
    </div>
  );
}

export default U9A;
